module.exports = __webpack_public_path__ + "img/CS-Profi2013-Assembly.29d0635b.jpg";